// ExportHandler.tsx
import { useEffect } from "react";
import { message } from "antd";

const ExportHandler = ({ reportType, format, month, year, status, employee }: any) => {
    console.log("Preparing export file")

    useEffect(() => {
        message.loading("Preparing export file...", 2);

        window.dispatchEvent(new CustomEvent("ai-chat", {
            detail: `📦 Preparing ${reportType} (${format.toUpperCase()}) for you...`
        }));

        setTimeout(() => {
            window.dispatchEvent(new CustomEvent("ai-chat", {
                detail: `⬇ Your ${reportType} (${format.toUpperCase()}) is getting downloaded!`
            }));
        }, 800);

        // Trigger actual exports inside pages
        window.dispatchEvent(new CustomEvent("ai-export-trigger", {
            detail: { reportType, format, month, year, status, employee }
        }));

    }, []);

    return <div style={{ padding: 20 }}>Exporting report...</div>;
};

export default ExportHandler;
